import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';
import { shuffle } from '../../utils/shuffleArray';
import getSalesAgentAppointmentTime from './getSalesAgentAppointmentTime.api';

const firebaseRef = firebase.database();

export default async function getRandomSalesAgent(bookedTime, callback) {
	let salesAgentIdArr = [];
	let availableIdArr = [];
	await firebaseRef
		.ref('/kavtek_sales_agents/' + PROJECT_CODE.projectCode)
		.once('value', (snapshot) => {
			var salesAgentsObj = snapshot.val();

			var salesAgentsKeys = Object.keys(salesAgentsObj);

			salesAgentsKeys.forEach((key) => {
				var salesAgentId = salesAgentsObj[key]['createrID'];

				salesAgentIdArr.push(salesAgentId);
			});
		});

	for (let salesAgentId of salesAgentIdArr) {
		let timeArr = [];
		await firebaseRef
			.ref('/client_appointments/' + PROJECT_CODE.projectCode)
			.orderByChild('createrID')
			.equalTo(salesAgentId)
			.once('value', (snapshot) => {
				let appointmentObj = snapshot.val();
				if (appointmentObj !== null) {
					let appointmentKeys = Object.keys(appointmentObj);

					appointmentKeys.forEach((key) => {
						let timeOfAppointment =
							appointmentObj[key].timeOfAppointment;

						timeArr.push(timeOfAppointment);
					});
				}
				let intersectionArr = timeArr.filter(
					(time) => Math.abs(time - parseInt(bookedTime)) <= 1000
				);
				if (intersectionArr.length === 0) {
					availableIdArr.push(salesAgentId);
				}
			});
	}
	if (availableIdArr.length === 0) {
		callback();
	} else {
		var newArr = availableIdArr.filter(
			(item) => item !== 'Ef4GvYvKGqRfngvfY1zJ71I7NuV2' //tyler
		);
		shuffle(newArr);
		var salesAgentIdChosen = newArr[0];
		callback(salesAgentIdChosen);
	}

	// getSalesAgentAppointmentTime(
	// 	salesAgentIdChosen,
	// 	bookedTimeArr,
	// 	(returned) => {
	// 		callback(returned);
	// 	}
	// );
}
